var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"label":_vm.label,"required":_vm.required,"accept":_vm.acceptedFormats,"prepend-icon":"mdi-upload","outlined":"","clearable":""},on:{"change":_vm.handleFileChange},scopedSlots:_vm._u([(_vm.error)?{key:"message",fn:function(){return [_vm._v(_vm._s(_vm.error))]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }